export const OrderPointType = {
  Loading: 'LOADING',
  Unloading: 'UNLOADING',
  FerryPassage: 'FERRY_PASSAGE',
  CustomsControl: 'CUSTOMS_CONTROL',
  Custom: 'CUSTOM'
}
